<script lang="ts" setup>
import { useTranslations } from '~/composables/translations';
import HomepageBtn from './HomepageBtn.vue';
import { computed } from 'vue';
import { generateMailTo } from '~/modules/mail-service';

const emit = defineEmits(['recommend']);
const { $i18n } = useTranslations('components/homepage/getListed');

const recommandMailTo = computed(() =>
  generateMailTo('marketplace.make@3ds.com', $i18n('recommendAService'), ''),
);
</script>
<template>
  <div class="get-listed px-10px--sm px-30px">
    <div
      class="homepage-max-content-container flex flex-column--sm align-items-center justify-space-between grid-gap-25px py-20px--sm py-30px"
    >
      <div class="text">
        <h4 class="title anti-h-css no-margin-bottom text-center--sm">
          {{ $i18n('title') }}
        </h4>
        <div class="subtitle text-center--sm">
          {{ $i18n('subtitle') }}
        </div>
      </div>
      <div class="get-listed-btn-ctn w-100--sm flex grid-gap-10px justify-center--sm">
        <HomepageBtn
          color="white"
          href="https://www.3ds.com/make/become-partner"
          target="_blank"
          class="get-listed-btn"
        >
          {{ $i18n('getListed') }}
        </HomepageBtn>
        <HomepageBtn
          color="blue-outline"
          @click="emit('recommend')"
          :href="recommandMailTo"
          class="recommend-btn"
        >
          {{ $i18n('recommend') }}
        </HomepageBtn>
      </div>
    </div>
  </div>
</template>
<style lang="css" scoped>
.get-listed {
  background-color: var(--blue-2);
  color: white;
}
</style>
